import { ComponentProps } from 'react';
import { Stack } from '@mui/material';
import { GroupCollapse } from '@/components/common/GroupCollapse';

type Props = ComponentProps<typeof GroupCollapse>;

export function FieldsGroup({ children, ...props }: Props) {
  return (
    <GroupCollapse defaultExpanded {...props}>
      <Stack direction="column" gap="14px">
        {children}
      </Stack>
    </GroupCollapse>
  );
}
